const telefono = 425;
const tablet = 768;
const desktop = 992;
const desktopXL = 1200;
const cantImgGaleria = 17;


document.addEventListener('DOMContentLoaded', function(){
   iniciarApp();
});

window.addEventListener('resize', function() {
   cambiarAparienciaSegunTam();
   mostrarEnlacesDesktop();
   cambiarGaleriaSegunTam();
});

function iniciarApp() {
   seleccPrimerElem();
   seleccionarElem();
   scrollNav();
   plegarYDesplegarNav();
   cambiarPagComoLoHacemos();
   activarBotonTienda();
   crearGaleria();
}

function cambiarPagClick(listaPaginas, accion) {

   listaPaginas.forEach(pagina => {
      pagina.addEventListener('click', function() {
         const pagsADeselecc = listaPaginas;

         pagsADeselecc.forEach(pagADeselecc => {
            pagADeselecc.classList.remove('seleccionado');
            pagADeselecc.classList.add('no-seleccionado');
         });

         pagina.classList.remove('no-seleccionado');
         pagina.classList.add('seleccionado');

         accion();
      });
   });
}

function scrollSuave(enlace) {
   enlace.addEventListener('click', function(evento) {

      evento.preventDefault();

      if(evento.target.nodeName == 'A'){
         const seccionScroll = evento.target.attributes.href.value;

         if(seccionScroll != "#"){ // Si no es el botón de plegar
         const seccion = document.querySelector(seccionScroll);
         seccion.scrollIntoView({ behavior: "smooth" });
         }
      }
      else if (enlace.nodeName == 'A') {
         const seccionScroll = enlace.attributes.href.value;

         if(seccionScroll != "#"){ // Si no es el botón de plegar
         const seccion = document.querySelector(seccionScroll);
         seccion.scrollIntoView({ behavior: "smooth" });
         }
      }
   });
}

// /////////////////////////////////////////////// Barra de navegación /////////////////////////////////////////////////

function scrollNav() { // Evita que al dar click en el enlace no se vaya de golpe a la sección
   const enlaces = document.querySelectorAll('.navegacion-principal a');
   const enlaceIrATienda = document.querySelector('.info .boton-recuadro a');

   scrollSuave(enlaceIrATienda);

   enlaces.forEach(enlace => {
      enlace.addEventListener('click', function(evento) {

         evento.preventDefault();

         if(evento.target.nodeName == 'A'){
            const seccionScroll = evento.target.attributes.href.value;

            if(seccionScroll != "#"){ // Si no es el botón de plegar
            const seccion = document.querySelector(seccionScroll);
            seccion.scrollIntoView({ behavior: "smooth" });
            }
         }
         else if (evento.target.nodeName == 'IMG') { // Si es el logo
            const seccion = document.querySelector('#inicio');
            seccion.scrollIntoView({ behavior: "smooth" });
         }
      });
   });
}

function plegarYDesplegarNav() {
   const boton = document.querySelector('.boton-plegar');

   boton.addEventListener('click', function () {
      const enlaces = document.querySelectorAll('.navegacion-principal a');

      if(boton.classList.contains('desplegado')) {
         enlaces.forEach(enlace => {
            enlace.style.display = "none";
         });

         boton.style.display = "block";
         boton.style.transform = "rotate(180deg)";
         boton.classList.remove('desplegado');

      }
      else {
         enlaces.forEach(enlace => {
            enlace.style.display = "block";
         });

         boton.classList.add('desplegado');
         boton.style.transform = "rotate(0deg)";
      }
   });
}

function mostrarEnlacesDesktop() { // Si la barra nav está oculta y el tamaño se cambia a desktop, se mostrarán los "a"
   anchoPantalla = window.innerWidth;
   const boton = document.querySelector('.boton-plegar');
   const enlaces = document.querySelectorAll('.navegacion-principal a');


   if( anchoPantalla >= desktop ) {
      enlaces.forEach(enlace => {
         enlace.style.display = "block";
      });
      boton.style.display = "none";
      return;
   }
   else if (anchoPantalla < desktop && boton.classList.contains('desplegado')){
      enlaces.forEach(enlace => {
         enlace.style.display = "block";
      });
      boton.style.display = "block";
   }
   else {
      enlaces.forEach(enlace => {
         enlace.style.display = "none";
      });
      boton.style.display = "block";
   }

}


// /////////////////////////////////////////////// Características /////////////////////////////////////////////////

function obtenerNombreElem(elemento) {
   let nombreElemento = elemento.attributes.class.value;  // retorna las clases en un string
   nombreElemento = nombreElemento.split(" ")[0]; // retorna la primer clase
   return nombreElemento;
}

function cambiarAparienciaSegunTam () {
   const elementos = document.querySelectorAll('.elemento');
   let nombElemSelecc = document.querySelector('.seleccionado');
    nombElemSelecc = obtenerNombreElem(nombElemSelecc);
    anchoPantalla = window.innerWidth;

    elementos.forEach((elemento) => {
      nombreElemActual = obtenerNombreElem(elemento);

      if (anchoPantalla < desktop && nombreElemActual != nombElemSelecc){
         elemento.querySelector('p').style.display = "none";
         elemento.querySelector('img').style.display = "none";
      }
      else {
         elemento.querySelector('p').style.display = "block";
         elemento.querySelector('img').style.display = "block";
      }
    });

}


function seleccionarElem() { // Realiza cambios al hacer click en un elemento de "Nuestros productos".
   const recuadros = document.querySelectorAll('.elemento .elemento-recuadro'); // Selecciona todos los recuadros negros

   recuadros.forEach(recuadroSelecc => {
      recuadroSelecc.addEventListener('click', function(evento){
         evento.preventDefault();

         nombreRecuadroSelecc = obtenerNombreElem(evento.target); // El elemento al que el evento hace referencia

         cambiarElemSelecc(recuadros, nombreRecuadroSelecc);

      });
   });
}

function seleccPrimerElem() { // Selecciona el primer elemento
   const recuadros = document.querySelectorAll('.elemento-recuadro');
   const primerRecuadro = "laser";

   cambiarElemSelecc(recuadros, primerRecuadro);
}

function cambiarElemSelecc(recuadros, nombreRecuadroSelecc) { // Cambia la apariencia según el elemento seleccionado
   const imagenFondo = document.querySelector('.caracteristicas--fondo');
   const elementos = document.querySelectorAll('.elemento');
   const cantRecuadros = recuadros.length;
   const anchoPantalla = window.innerWidth;

   const pagina = document.querySelector('html');
   let admiteWebp = true;

   if(pagina.classList.contains('no-webp')) {
      admiteWebp = false;
   }

   for (i = 0; i < cantRecuadros; i++) {
      const recuadroTemp = recuadros[i];
      const clasesRecuadroTemp = recuadroTemp.attributes.class.value;
      const nombreRecuadroTemp = clasesRecuadroTemp.split(" ")[0];

      if(nombreRecuadroTemp == nombreRecuadroSelecc) {
         recuadroTemp.classList.remove('no-seleccionado');
         recuadroTemp.classList.add('seleccionado');

         if(admiteWebp) {
            imagenFondo.style.backgroundImage = "url(build/img/caracteristicas/"+nombreRecuadroSelecc+".webp)";
         }
         else {
            imagenFondo.style.backgroundImage = "url(build/img/caracteristicas/"+nombreRecuadroSelecc+".jpg)";
         }

         if(anchoPantalla < desktop) { // Muestra la información del elemento
            elementos[i].querySelector('p').style.display = "block";
            elementos[i].querySelector('img').style.display = "block";
         }
      }
      else if (clasesRecuadroTemp.includes("seleccionado")) {
         recuadroTemp.classList.remove('seleccionado');
         recuadroTemp.classList.add('no-seleccionado');

         if(anchoPantalla < desktop) { // Oculta la información del elemento
            elementos[i].querySelector('p').style.display = "none";
            elementos[i].querySelector('img').style.display = "none";
         }
      }
   }
}

// /////////////////////////////////////////////// Cómo lo hacemos /////////////////////////////////////////////////

function cambiarPagComoLoHacemos() {
   const paginas = document.querySelectorAll('.paginas-proceso .boton-pagina');
   const imagen = document.querySelector('.como-lo-hacemos--imagen');
   const srcImagen = imagen.querySelector('source');
   const imgImagen = imagen.querySelector('img');
   const accion = function() {
      const pagCliqueada = document.querySelector('.paginas-proceso .seleccionado p').innerHTML;
      const informacionPags = document.querySelectorAll('.como-lo-hacemos--informacion .no-mostrado, .como-lo-hacemos--informacion .mostrado');

      srcImagen.attributes.srcset.value = "build/img/como-lo-hacemos/"+pagCliqueada+".webp";
      imgImagen.attributes.src.value = "build/img/como-lo-hacemos/"+pagCliqueada+".jpg";

      informacionPags.forEach((informacionPag, i) => {
         if( (i+1) == pagCliqueada ) {
            informacionPag.classList.remove('no-mostrado');
            informacionPag.classList.add('mostrado');
         }
         else {
            informacionPag.classList.remove('mostrado');
            informacionPag.classList.add('no-mostrado');
         }
      });
   };
   cambiarPagClick(paginas, accion);
}

// /////////////////////////////////////////////// Galería /////////////////////////////////////////////////

function obtenerCantImgPorPag() {
   const tamPantalla = window.innerWidth;

   if ( tablet <= tamPantalla && tamPantalla < desktop) {
      return 6;
   } else if (desktop <= tamPantalla && tamPantalla < desktopXL) {
      return 8;
   } else if (desktopXL < tamPantalla) { // no es un "else" solo porque contemplaría el tamaño del teléfono
      return 10;
   }
      return 4;
}

function mostrarImagen(indice) {
   const imagen = document.createElement('picture');
   const overlay = document.createElement('DIV');
   const body = document.querySelector('body');
   const btnCerrarModal = document.createElement('P');

   imagen.innerHTML = `
      <source srcset="build/img/galeria/Imagen${indice}.webp" type="image/webp">
      <img loading="lazy" width="200" height="200" src="build/img/galeria/Imagen${indice}.jpg" alt="Imagen de galería">
   `;

   // Agrega el modal
   overlay.appendChild(imagen);
   overlay.classList.add('overlay');
   overlay.onclick = function() {
      overlay.remove();
      body.classList.remove('fijar-body');
   };
   body.appendChild(overlay);
   body.classList.add('fijar-body');

   // Cierra el modal
   btnCerrarModal.textContent = 'X';
   btnCerrarModal.classList.add('btn-cerrar-img');
   btnCerrarModal.onclick = function() {
      overlay.remove();
      body.classList.remove('fijar-body');
   };
   overlay.appendChild(btnCerrarModal);

}

function cargarImgs(primerImgAMostrar, cantImgAMostrar, divGaleria){

   const ultImgAMostrar = primerImgAMostrar + cantImgAMostrar;

   for( let i = primerImgAMostrar; i < ultImgAMostrar; i++ ) {
      const imagen = document.createElement('picture');

      imagen.innerHTML = `
         <source srcset="build/img/galeria/thumb/Imagen${i}.webp" type="image/webp">
         <img loading="lazy" width="200" height="200" src="build/img/galeria/thumb/Imagen${i}.jpg" alt="Imagen de galería">
      `;

      imagen.onclick = function() {
         mostrarImagen(i);
      };

      divGaleria.appendChild(imagen);
   }

}

function colocarBotonesGaleria(cantImgPorPag, pagSelecc) {
   const espacioPags = document.querySelector('.galeria-paginas');
   let residuo = cantImgGaleria%cantImgPorPag; // El resíduo es la cantidad de imágenes que cargará en la última página
   let cantPags = cantImgGaleria/cantImgPorPag;

   if(residuo > 0) {
      cantPags = cantPags+1;
   }

   espacioPags.innerHTML = "";

   for (let i = 1; i <= cantPags; i++) {
      const recuadroPag = document.createElement('div');
      recuadroPag.classList.add('boton-pagina');

      if (i == pagSelecc) {
         recuadroPag.classList.add('seleccionado');
      } else {
         recuadroPag.classList.add('no-seleccionado');
      }
      recuadroPag.innerHTML = `<p>${i}</p>`;

      espacioPags.appendChild(recuadroPag);
   }

}

function cambiarPagGaleria(cantImgPorPag) { // Carga las imágenes correspondientes al dar click en el botón
   const paginas = document.querySelectorAll('.galeria-paginas .boton-pagina');

   const accion = function() {
      let cantImgAMostrar = cantImgGaleria % cantImgPorPag;
      const pagCliqueada = document.querySelector('.galeria-paginas .seleccionado p').innerHTML;
      const numImgInicial = ((pagCliqueada-1)*cantImgPorPag)+1;
      const galeria = document.querySelector('.galeria--imagenes');
      let ultimaPag = (cantImgGaleria/cantImgPorPag)+1;

      galeria.innerHTML = "";
      ultimaPag = Math.trunc(ultimaPag);


      if((cantImgGaleria%cantImgPorPag) > 0 && ultimaPag == pagCliqueada) {
         cargarImgs(numImgInicial, cantImgAMostrar, galeria);
      } else {
         cargarImgs(numImgInicial, cantImgPorPag, galeria);
      }
   };

   cambiarPagClick(paginas, accion);
}

function crearGaleria() {
   const galeria = document.querySelector('.galeria--imagenes');
   let cantImgPorPag = obtenerCantImgPorPag();
   let primerImagen;

   cargarImgs(1, cantImgPorPag, galeria);

   /*
   primerImagen = document.querySelector('.galeria--imagenes picture');
   primerImagen.classList.add("1");
   */

   colocarBotonesGaleria(cantImgPorPag, 1);
   cambiarPagGaleria(cantImgPorPag);
}

function cambiarGaleriaSegunTam() {

   let primerImgNum;
   const galeria = document.querySelector('.galeria--imagenes');
   let cantImgPorPag = obtenerCantImgPorPag();

   try {
      primerImgNum = document.querySelector('.galeria--imagenes picture').attributes.class.value;
   } catch (error) {
      primerImgNum = 1;
   }
   galeria.innerHTML = "";

   cargarImgs(primerImgNum, cantImgPorPag, galeria);
   colocarBotonesGaleria(cantImgPorPag, 1);
   cambiarPagGaleria(cantImgPorPag);

}

// /////////////////////////////////////////////// Tienda /////////////////////////////////////////////////

function activarBotonTienda() {
   const btnIrAContacto = document.querySelector('.tienda--recuadro-borde .boton-recuadro a');

   scrollSuave(btnIrAContacto);
}
